module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HIwzKw/tc-custom/9781913618278.jpg?1729082635124",
      "alt": "This image is the cover for the book Ancient Egypt, Ancient Wisdom for the New Age"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ancient Egypt, Ancient Wisdom for the New Age\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Discover how the wisdom of ancient Egypt can provide guidance for living in the modern world with this fascinating, fully illustrated guide.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Today, there are countless New Age philosophies designed for self-improvement and spiritual development, but none of them match the timeless wisdom contained within the mysteries of Ancient Egypt. This volume introduces readers to the ways of the pharaohs; their relationship to the land and the river Nile; their positive attitudes toward death and the afterlife as set down in "), _c('i', [_vm._v("The Book of the Dead")]), _vm._v("; and their sacred rites, symbols, and stones which have had a profound influence on cultures throughout history."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Fully illustrated with magnificent artwork, this volume also covers Ancient Egyptian history, archeological sites, mysterious relics, and speculation about the meaning and power of the pyramids.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Zelda Sharif\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Fox Chapel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0